import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "hooks/useAuth";
import { AppErrorProvider } from "hooks/useAppError";
import { AppErrorSnackbar } from "components/AppErrorSnackbar";

import App from "App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const theme = createTheme({
  palette: {
    primary: { main: "#006ac9" },
  },
});

root.render(
  <StrictMode>
    <BrowserRouter>
      <AppErrorProvider>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <App />
            <AppErrorSnackbar />
          </ThemeProvider>
        </AuthProvider>
      </AppErrorProvider>
    </BrowserRouter>
  </StrictMode>,
);
